import { defineComponent as o, createBlock as t, openBlock as r, unref as m, mergeProps as p, withCtx as i, createElementVNode as a } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const v = /* @__PURE__ */ o({
  name: "IconSiren",
  __name: "IconSiren",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (d, e) => (r(), t(m(c), p(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        a("path", { d: "M12.75 3a.75.75 0 0 0-1.5 0v1.414a.75.75 0 0 0 1.5 0V3M4.97 4.97a.75.75 0 0 1 1.06 0l1 1a.75.75 0 0 1-1.06 1.06l-1-1a.75.75 0 0 1 0-1.06m14.06 1.06a.75.75 0 0 0-1.06-1.06l-1 1a.75.75 0 0 0 1.06 1.06l1-1M5.164 11a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h1.414A.75.75 0 0 1 5.164 11m16.586 0A.75.75 0 0 1 21 11.75h-1.414a.75.75 0 0 1 0-1.5H21A.75.75 0 0 1 21.75 11m-8.325-1.246a.75.75 0 0 1 .821.671l.3 3a.75.75 0 0 1-1.492.15l-.3-3a.75.75 0 0 1 .671-.821" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M6.321 17.25 7.12 9.276A2.25 2.25 0 0 1 9.358 7.25h5.285a2.25 2.25 0 0 1 2.238 2.026l.798 7.974H18a2.25 2.25 0 0 1 2.25 2.25v1A1.25 1.25 0 0 1 19 21.75H5a1.25 1.25 0 0 1-1.25-1.25v-1A2.25 2.25 0 0 1 6 17.25h.321m2.29-7.825A.75.75 0 0 1 9.358 8.75h5.285a.75.75 0 0 1 .746.675l.782 7.825H7.83l.78-7.825M5.25 19.5A.75.75 0 0 1 6 18.75h12a.75.75 0 0 1 .75.75v.75H5.25V19.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
